<template>
  <div>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
               action-buttons-name="PresentacionCargaLpfActionButtons" filter toolbar :toolbar-title="toolbarTitle"
               :search-text="searchText">
      <slot slot="toolbar-table"></slot>
    </DataTable>
    <presentacion-create-popup v-if="canCreate" ref="creacionPopup"></presentacion-create-popup>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newPresentacion">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import PresentacionCreatePopup from '../components/PresentacionCargaLpfCreatePopup.vue'

const CLUB_INDEX_IN_TABLE = 6

export default {
  methods: {
    newPresentacion () {
      this.$refs.creacionPopup.showDialog()
    }
  },
  data () {
    return {
      filterPath: 'filters/cargalpfpresentations'
    }
  },
  props: {
    path: {
      type: String,
      default: 'presentacion-carga-lpf'
    },
    initialProperties: {
      type: Array,
      default: () => { return ['nombre', 'mandatoryPresentationType', 'created', 'submitted', 'period', 'estadoDisplayTable'] }
    },
    initialHeaders: {
      type: Array,
      default: () => { return [] }
    },
    toolbarTitle: {
      type: String,
      default: 'Presentaciones LPF'
    },
    searchText: {
      type: String,
      default: 'Buscar por nombre de presentación o periodo'
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },

  components: {
    DataTable,
    PresentacionCreatePopup
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddPresentaciones
    },
    headers () {
      if (this.initialHeaders.length > 0) {
        return this.initialHeaders
      }

      let headers = [
        { text: 'Nombre', align: 'left', value: 'nombre', sortable: false },
        { text: 'Tipo', value: 'mandatory_presentation_type', sortable: true },
        { text: 'Fecha de Creación', value: 'created' },
        { text: 'Fecha de Presentación', value: 'submitted' },
        { text: 'Periodo', value: 'period', sortable: true },
        { text: 'Estado', value: 'status', filterField: true },
        { text: 'Año', value: 'year', filterField: true, visible: false },
        { text: 'Club', value: 'club', filterField: true },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      return headers
    },
    properties () {
      let properties = this.initialProperties
      properties.splice(CLUB_INDEX_IN_TABLE, 0, 'club.nombre')
      return properties
    }
  }
}
</script>
